const _excluded = ["onChange", "properties", "translationContext", "modelPrefix", "storeKey", "templates", "dateFormat"];var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}function _objectWithoutProperties(e, t) {if (null == e) return {};var o,r,i = _objectWithoutPropertiesLoose(e, t);if (Object.getOwnPropertySymbols) {var n = Object.getOwnPropertySymbols(e);for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);}return i;}function _objectWithoutPropertiesLoose(r, e) {if (null == r) return {};var t = {};for (var n in r) if ({}.hasOwnProperty.call(r, n)) {if (-1 !== e.indexOf(n)) continue;t[n] = r[n];}return t;}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';
import rison from '@huridocs/rison';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { t } from "../../I18N";
import FormGroup from "../../DocumentForm/components/FormGroup";
import { getAggregationSuggestions } from "../actions/libraryActions";
import { selectTemplates } from "../../utils/coreSelectors";
import { searchParamsFromLocationSearch } from "../../utils/routeHelpers";

import DateFilter from "./DateFilter";
import NestedFilter from "./NestedFilter";
import NumberRangeFilter from "./NumberRangeFilter";
import SelectFilter from "./SelectFilter";
import TextFilter from "./TextFilter";

const extractRelationshipLabel = (filteredProperty, label, templates) => {
  const relatedTemplate = templates.find((template) => template._id === filteredProperty.content);
  if (!(relatedTemplate !== null && relatedTemplate !== void 0 && relatedTemplate.properties)) return label;

  const templateProperty = relatedTemplate.properties.find(
    (property) => {var _filteredProperty$inh;return property._id === (filteredProperty === null || filteredProperty === void 0 ? void 0 : (_filteredProperty$inh = filteredProperty.inherit) === null || _filteredProperty$inh === void 0 ? void 0 : _filteredProperty$inh.property);}
  );

  return templateProperty !== null && templateProperty !== void 0 && templateProperty.content ? t(templateProperty.content, label, undefined, false) : label;
};

const optionUrl = (value, name, query) => {
  const q = rison.encode(_objectSpread(_objectSpread({},
  query), {}, {
    filters: _objectSpread(_objectSpread({}, query.filters), {}, { [name]: { values: [value] } }),
    from: 0,
    limit: 30,
    includeUnpublished: false,
    order: 'desc',
    sort: 'creationDate',
    unpublished: false,
    allAggregations: false })
  );

  return `/library/?q=${q}`;
};

const labelForOption = (filteredProperty, option, templates) => {
  switch (true) {
    case option.id === 'missing':
      return t('System', 'No Label', undefined, false);
    case filteredProperty.type === 'relationship':
      return extractRelationshipLabel(filteredProperty, option.label, templates);
    default:
      return t(filteredProperty.content, option.label, undefined, false);
  }
};

const prepareOptions = (property, location, templates) => {
  const query = searchParamsFromLocationSearch(location) || {};
  const filteredProperty = _objectSpread(_objectSpread({},
  property), {}, {
    options: property.options.filter((option) => option.id !== 'any') });

  return filteredProperty.options.map((option) => {
    const finalTranslatedOption = _objectSpread(_objectSpread({},
    option), {}, {
      label: labelForOption(filteredProperty, option, templates),
      url: optionUrl(option.value, property.name, query) });


    if (option.options) {
      const translatedSubOptions = option.options.map((subOption) => _objectSpread(_objectSpread({},
      subOption), {}, {
        label: t(filteredProperty.content, subOption.label, undefined, false),
        url: optionUrl(subOption.value, property.name, query) })
      );
      finalTranslatedOption.options = translatedSubOptions;
    }

    return finalTranslatedOption;
  });
};

const getPropertyType = (property, templates) => {var _property$inherit;
  if ((_property$inherit = property.inherit) !== null && _property$inherit !== void 0 && _property$inherit.property) return property.inherit.type;
  //relationships v2
  if (property.type === 'newRelationship') {
    if (property.denormalizedProperty) {
      for (let i = 0; i < templates.length; i += 1) {
        const template = templates[i];
        const candidateProperty = template.properties.find(
          (p) => p.name === property.denormalizedProperty
        );
        if (candidateProperty) {
          return candidateProperty.type;
        }
      }
      return 'text';
    }

    return 'select';
  }
  // /v2
  return property.type;
};

const FiltersFromProperties = (_ref) =>








{let { onChange = () => {}, properties, translationContext = '', modelPrefix = '', storeKey, templates, dateFormat = '' } = _ref,props = _objectWithoutProperties(_ref, _excluded);
  const location = useLocation();
  return (/*#__PURE__*/
    React.createElement(React.Fragment, null,
    properties.map((property) => {
      const type = getPropertyType(property, templates);

      const commonProps = {
        model: `.filters${modelPrefix}.${property.name}`,
        label: t(translationContext, property.label),
        onChange
      };

      const propertyOptions = property.options ?
      prepareOptions(property, location, templates) :
      [];

      let filter = /*#__PURE__*/React.createElement(TextFilter, commonProps);

      switch (type) {
        case 'numeric':
          filter = /*#__PURE__*/React.createElement(NumberRangeFilter, commonProps);
          break;

        case 'select':
        case 'multiselect':
        case 'relationship':
          filter = /*#__PURE__*/
          React.createElement(SelectFilter, _extends({},
          commonProps, {
            lookup: getAggregationSuggestions.bind(null, storeKey, property.name),
            options: propertyOptions,
            prefix: property.name,
            showBoolSwitch: property.type === 'multiselect' || property.type === 'relationship',
            sort: property.type === 'relationship',
            totalPossibleOptions: propertyOptions.length,
            allowSelectGroup: true })
          );

          break;

        case 'nested':
          filter = /*#__PURE__*/
          React.createElement(NestedFilter, _extends({},
          commonProps, {
            property: property,
            aggregations: props.aggregations })
          );

          break;

        case 'date':
        case 'multidate':
        case 'multidaterange':
        case 'daterange':
          filter = /*#__PURE__*/React.createElement(DateFilter, _extends({}, commonProps, { format: dateFormat }));
          break;

        default:
          break;
      }

      return /*#__PURE__*/_jsx(FormGroup, {}, property.name, filter);
    })
    ));

};












export function mapStateToProps(state, props) {
  return {
    dateFormat: state.settings.collection.get('dateFormat'),
    aggregations: state[props.storeKey].aggregations,
    storeKey: props.storeKey,
    templates: selectTemplates(state)
  };
}

export { FiltersFromProperties };
export default connect(mapStateToProps)(FiltersFromProperties);